import { CdkDrag, CdkDragMove, CdkDropList, CdkDropListGroup, moveItemInArray } from '@angular/cdk/drag-drop';
import { ViewportRuler } from "@angular/cdk/overlay";
import { Component, Input, Output, OnInit, EventEmitter, ViewChild, OnChanges, SimpleChange, ElementRef, Renderer2, Injectable } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { AmplifyService } from 'aws-amplify-angular';
import { HttpService } from '../../http/http.service';

import { GeneralService } from 'src/app/shared/services/general.service';
import { PipeObjectFilter } from '../../pipe/pipe-objectFilter';
import { Observable } from 'rxjs';
import { FileUpload } from 'src/app/shared/utils/fileUpload';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { VimeoService } from '../../services/vimeo.service';

declare var $: any;
declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;

declare const window: any;

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'file-upload',
  templateUrl: './fileUpload.component.html',
  styleUrls: ['./fileUpload.component.scss']
})
export class FileUploadComponent extends FileUpload implements OnInit, OnChanges {

  Object = Object;

  @ViewChild('gallery', { static: false }) galleryEl: ElementRef;

  @ViewChild(MatMenuTrigger, { static: true }) menuTrigger: MatMenuTrigger;

  @ViewChild(CdkDropListGroup, { static: true }) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList, { static: true }) placeholder: CdkDropList;

  @Input() tagArea: Observable<string> = null;
  @Input() tagType: Observable<string> = null;

  @Input() showToolbar: any = true;

  @Input() min: any = -1;

  @Input() btnFile: ElementRef;
  @Input() btnCamera: ElementRef;

  @Input() galleryTitle: any = '';

  @Input() showFilename: any = true;

  @Input() disabled: any = false;

  @Input() buttonText: any = '';

  @Input() webcam: boolean = false;

  @Input() ownerId: any = null;

  @Input() firstFileHighlight: any = null;

  @Input() upload: boolean = true;
  @Input() accept: any = ['jpeg', 'jpg', 'gif', 'png', 'webp', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'mp4'];
  @Input() acceptTag: any = "";
  @Input() maxFileSize: any = 270; // mb

  @Input() actions: any = ['delete', 'undelete', 'description', 'drag', 'tags'];
  @Input() resizes: Array<any> = ['original', 'extralarge', 'large', 'medium', 'thumb'];

  @Input() origin: any = '';
  @Input() ref: any = '';

  @Input() bucket: number = 1;
  @Input() level: any = 'protected';
  @Input() multiple: boolean = true;
  @Input() multipleSelect: boolean = true;

  @Input() max: any = -1;

  @Input() replace: boolean = false;
  @Input() gallery: any = '';

  @Output() selecting = new EventEmitter();

  @Input() customTags: any = [];
  @Input() filterByTags: any = [];
  @Input() applyTags: any = [];
  @Input() uploadTags: any = [];

  @Input()
  set files(val: any) {
    if (typeof val == 'undefined') {
      val = [];
      return;
    }

    this._files = (!this.filterByTags?.length ? val : val.filter(item => !!item?.tags?.filter(i => this.filterByTags.includes(i))?.length)).sort((a, b) => a.sort - b.sort);

    this._files.map(item => {
      item.thumb = this.getFile(item, 'thumb');
    });

    this.filesChange.emit(this._files);
    this.setCallback({ action: 'setFiles', files: this._files });


  }
  get files() {
    return this._files;
  }

  showGallery: boolean = false;

  galleryOpened: any = false;

  viewInstance: any = {};

  webcamActive: boolean = false;
  webcamCaptured: boolean = false;
  webcamMessage: boolean = false;
  webcamLoading: boolean = false;
  private webCamstream: any = false;
  private webcamPictureResult: any = false;
  @ViewChild('player') player: ElementRef;
  @ViewChild('snapshot') snapshot: ElementRef;

  webcamSnapshot: CanvasRenderingContext2D;

  menuOpenedState: boolean = false;
  menuOpened: any = false;

  allChecked: boolean = false;

  deletedIds: any = [];

  tagsList: any = [];

  fileBlockActive = 0;

  descriptionFocus = null;

  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;


  constructor(
    protected toast: SnackBarService,
    protected as: AmplifyService,
    protected viewportRuler: ViewportRuler,
    protected http: HttpService,
    protected gs: GeneralService,
    public renderer: Renderer2,
    protected vimeo: VimeoService
  ) {
    super(toast, as, http, gs, vimeo);

    this.target = null;
    this.source = null;


  }
  ngOnInit() {
    if (this.btnFile) {
      this.renderer.setAttribute(this.btnFile, 'accept', this.accept);
      if (this.disabled)
        this.renderer.setAttribute(this.btnFile, 'disabled', this.disabled);
      this.renderer.listen(this.btnFile, 'change', (event) => this.fileEvent(event))
    }
    if (this.btnCamera) {
      if (this.disabled)
        this.renderer.setAttribute(this.btnCamera, 'disabled', this.disabled);
      this.renderer.listen(this.btnCamera, 'click', () => this.webcamInit())
    }
    this.updateTagsList();
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (changes?.tagType || changes?.customTags)
      this.updateTagsList();
  }

  updateTagsList() {
    this.tagsList = (this.tagArea == undefined || this.tagType == undefined ? [] : this.gs.getTags(this.tagArea, this.tagType)).sort((a, b) => a?.tag.localeCompare(b?.tag)).concat(this.customTags.map(item => { item.attr = {}; return item }));
  }

  ngAfterViewInit() {
    if (this.btnFile) {
      this.galleryEl.nativeElement.style.display = 'none';
    } else {
      let phElement = this.placeholder.element.nativeElement;
      phElement.style.display = 'none';
      phElement.parentNode.removeChild(phElement);
    }
  }

  action(event, action, id: any = 'all', data: any = null) {
    if (event != null)
      event.stopPropagation();

    var th = this;
    var key = this.arraySearch(this._files, 'file_id', id);

    if (!key && id != 'all')
      return;

    switch (action) {

      case 'check':
        if (typeof this._files[key] === 'undefined')
          return false;

        if (typeof this._files[key].checked !== 'undefined')
          delete this._files[key].checked;
        else
          this._files[key].checked = true;

        this.selecting.emit({ files: this._files.filter(item => item.checked) });
        break;
      case 'checkAll':
        var pipeFilter = new PipeObjectFilter();

        var allActive = pipeFilter.transform(this._files, 'status', 1);

        this.allChecked = pipeFilter.transform(allActive, 'checked', true).length == allActive.length;

        allActive.forEach(function (item) {
          if (th.allChecked)
            delete item.checked;
          else
            item.checked = true;
        });

        this.selecting.emit({ files: this._files.filter(item => item.checked) });
        break;
      case 'deleteChecked':
        this.deletedIds = [];
        this._files.forEach(function (item) {
          if (item.checked && item?.file_id) {
            item.status = -5;
            th.deletedIds.push(item.file_id);
            delete item.checked;
          }
        });

        if (!this.deletedIds.length)
          return this.log(1, "Ocorreu um erro, entre em contato com administrador.", 3500);

        if (this.actions.indexOf('undelete') > -1)
          this.log(1, "Arquivos excluídos com sucesso.", 3500, [], 'Desfazer', function () { th.action(null, 'undelete', 'all', th.deletedIds); });
        else
          this.log(1, "Arquivos excluídos com sucesso.", 3500);

        this.APIdelete(this.deletedIds);

        break;
      case 'delete':
        if (!this._files[key]?.file_id) {
          delete this._files[key];
          return;
        }

        this.deletedIds = [this._files[key]?.file_id];
        this._files[key].status = -5;

        if (this.actions.indexOf('undelete') > -1) {
          this.log(1, "Arquivo excluído!", 3500, [], 'Desfazer', function () { th.action(null, 'undelete', 'all', th.deletedIds); });
        } else {
          this.log(1, "Arquivo excluído!", 2500);
        }

        this.APIdelete(this.deletedIds);

        this.menuClose();
        break;
      case 'undelete':

        for (var i = 0; i < data.length; i++)
          this.arraySearch(this._files, 'file_id', data[i], true).status = 1;

        data = [];

        this.APIundelete(this.deletedIds);

        break;
      case 'tag':
        if (!Array.isArray(this._files[key].tags))
          this._files[key].tags = [];

        var p = this._files[key].tags.indexOf(data);
        if (p > -1)
          this._files[key].tags.splice(p, 1);
        else
          this._files[key].tags.push(data);

        this._files[key].tagUpdated = true;

        break;
      case 'descriptionKeyDown':
        if (event.keyCode == 13) {
          $('#fileBlock_' + id.file_id + ' .fileNameInput').blur();
          return false;
        }
        break;
      case 'descriptionFocus':
        this.menuClose(false);
        this.descriptionFocus = id;
        $('#fileBlock_' + id + ' .fileNameInput').focus();
        break;
      case 'description':
        id.description = $(event.target).val();
        this.APIdescription(id);
        break;
      case 'zoom':

        if (this.fileIsImage(id)) {
          //var images = this._files.filter(item => item.status == 1).map( item =>{ return {src: this.getFile(item,'large'), thumb: this.getFile(item,'thumb'), subHtml:item.description }; });

          var images = [];
          let index: any = data;

          Object.entries(this._files.filter(item => item.status == 1)).forEach(([key, item]: any) => {

            let src = this.getFile(item, 'large', true);

            if (item.type.indexOf('video') > -1) {
              let video = this.getFile(item, 'video', true);
              let vimeoId = false;
              if (video?.filename?.indexOf('vimeo') > -1) {
                video.filename = video.filename.replace('https://vimeo.com/', '');
                vimeoId = (video.filename.match(new RegExp("/", "g")) || []).length > 0 ? video.filename.substr(0, video.filename.indexOf('/')) : video.filename;
              }

              images.push({
                html: vimeoId ?
                  '<iframe *ngIf class="video" src="https://player.vimeo.com/video/' + vimeoId + '" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
                  : '<div><video controls width="100%" video="100%" style="width:100%, height:100%; position:absolute; top:50%; transform:translateY(-50%);"><source src="' + video.filename + '" type="video/mp4"></video></div>',
                title: item.description
              })
            } else
              images.push(
                {
                  src: src.filename,
                  w: src[0]?.width || 0,
                  h: src[0]?.height || 0,
                  title: item.description
                }
              );
          });

          var pswpElement = document.querySelectorAll('.pswp')[0];
          // Initializes and opens PhotoSwipe

          var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, {
            index: index, // start at first slide
            history: false,
            timeToIdle: 0
          });

          gallery.listen('afterChange', () => {
            let items = gallery.items;
            if (!!items?.length) {
              let cur = gallery.getCurrentIndex();

              Object.entries(items).forEach(([item, v]) => {
                if (item != cur && items[item]?.content && items[item] && typeof items[item].container !== 'undefined' && items[item]?.container)
                  items[item].container.innerHTML = '';
              });

              if (items[cur]?.content && typeof items[cur].container !== 'undefined')
                items[cur].container.innerHTML = items[cur]?.content;

              if (items[cur]?.content?.indexOf('video') > -1)
                pswpElement.classList.add('tiny');
              else
                pswpElement.classList.remove('tiny');
            } else {
              pswpElement.classList.remove('tiny');
            }
          });

          gallery.listen('close', (e) => {

            this.galleryOpened = false;
            if (this.viewInstance?.lightGalleryOpened)
              this.viewInstance.lightGalleryOpened = false;

            pswpElement.querySelectorAll('iframe').forEach(i => {
              i.remove();
            });
          });

          gallery.init();

          this.galleryOpened = gallery;

        } else {
          window.open(this.getFile(id));
        }

        break;

    }
  }

  getFilesActive() {
    return this._files.filter(item => item.status == 1).length;
  }

  menuOpen(menu, id, event) {
    if (this.target)
      return;

    if (typeof event !== 'undefined')
      event.stopPropagation();

    if (this.menuOpened && this.menuOpened != menu)
      this.menuClose();

    this.menuOpened = menu;
    this.menuOpenedState = true;
    this.fileBlockActive = id;
    //menu.openMenu();
  }

  menuClosed() {
    this.menuOpenedState = false;
  }

  menuClose(reset = true) {
    if (this.menuOpened)
      this.menuOpened.closeMenu();

    var file = this.arraySearch(this._files, 'file_id', this.fileBlockActive, true);
    if (file.tagUpdated)
      this.APIupdateTag(file);

    this.menuOpened = false;

    if (reset)
      this.fileBlockActive = 0;
  }

  setActive(event, id) {
    if (this.fileBlockActive != id && this.menuOpened)
      this.menuClose();

    this.fileBlockActive = id;
    event.stopPropagation();
  }
  /* DRAG AND DROP reference https://stackblitz.com/edit/angular-dyz1eb */
  dragMoved(e: CdkDragMove) {
    if (this.disabled)
      return;

    let point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }

  dropListDropped() {
    if (!this.target || this.disabled)
      return;

    let phElement = this.placeholder.element.nativeElement;
    let parent = phElement.parentElement;

    phElement.style.display = 'none';

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

    this.target = null;
    this.source = null;

    if (this.sourceIndex != this.targetIndex) {
      moveItemInArray(this._files, this.sourceIndex, this.targetIndex);
      this.APIupdateSort();
    }
  }

  dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop == this.placeholder)
      return true;

    if (drop != this.activeContainer)
      return false;

    let phElement = this.placeholder.element.nativeElement;
    let sourceElement = drag.dropContainer.element.nativeElement;
    let dropElement = drop.element.nativeElement;

    let dragIndex = __indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    let dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dropIndex > dragIndex
      ? dropElement.nextSibling : dropElement));

    this.placeholder.enter(drag, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
    return false;
  }

  /** Determines the point of the page that was touched by the user. */
  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
    const point = __isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  webcamInit() {
    this.webcamLoading = true;

    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        this.webCamstream = stream;
        this.player.nativeElement.srcObject = stream;
        this.webcamLoading = false;
      })
      .catch(err => {
        this.webcamMessage = true;
        this.webcamLoading = true;
      });

    this.webcamActive = true;
  }

  webcamClose() {
    this.webcamActive = false;

    if (this.webCamstream)
      this.webCamstream?.getTracks().forEach(track => track.stop())
  }

  webcamCapture() {
    var snapshotCanvas = this.player.nativeElement;
    var canvas = document.createElement('canvas');
    canvas.width = snapshotCanvas.videoWidth;
    canvas.height = snapshotCanvas.videoHeight;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(this.player.nativeElement, 0, 0, snapshotCanvas.videoWidth, snapshotCanvas.videoHeight);

    this.webcamPictureResult = canvas.toDataURL('image/jpeg');
    this.snapshot.nativeElement.src = this.webcamPictureResult;

    this.webcamCaptured = true;
  }


  webcamRedo() {
    this.webcamCaptured = false;
    this.webcamPictureResult = false;
  }

  webcamUsePicture() {
    if (!this.webcamPictureResult)
      return;
    let file = this.urlToBlob(this.webcamPictureResult, 'image/jpeg');
    file['name'] = 'capture.jpg';

    this.fileEvent([file]);
    this.webcamClose();
  }

  btnDrop(e) {
    if (e.target.classList.contains('backDrop'))
      e.target.parentNode.parentNode.classList?.remove('over');

    else if (e.target.nodeName == 'INPUT')
      $(e.target).parent()[0].classList?.toggle('over', e.type != 'dragleave');

    else if (e.target.classList.contains('btnAdd')) {
      if (e.type == 'dragover') {
        $('.fileBlock-container').removeClass('over');
        $(e.target).parents('.fileBlock-container').addClass('over');
      }

      e?.target?.classList?.toggle('over', e.type != 'dragleave');
    }
  }


}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
};

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
  const { top, bottom, left, right } = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}